// config.js
const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://apipathwp.com";

export default baseURL;
